var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prize-card"},[_c('pageTitle',{attrs:{"pageTitle":_vm.$t('lang.k_227001')}},[_c('span',{staticClass:"notice"},[_vm._v(_vm._s(_vm.$t('lang.k_227002')))])]),_c('div',{staticClass:"prize-info"},[_c('prize-list',{attrs:{"source":'0',"roomId":_vm.roomId}})],1),_c('begin-play',{attrs:{"webinarId":_vm.$route.params.str}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }